const EmptyState = ({ icon: Icon, title, body, tone = "muted" }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
    <div
      className={`flex h-10 w-10 items-center justify-center rounded-xl ${
        tone === "danger" ? "bg-tone-rose-soft text-tone-rose" : "bg-background-tertiary text-text-secondary"
      }`}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </div>
    <div className="space-y-1">
      <p className="text-sm font-medium text-text-primary">{title}</p>
      <p className="mx-auto max-w-[300px] text-xs text-text-secondary">{body}</p>
    </div>
  </div>
);

export default EmptyState;
